export default {"src":"/_next/static/media/linkedin-blu.9073b414.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};